const constants = {
  SET_ACTIVE_PROFILE_ELEMENTS: "SET_ACTIVE_PROFILE_ELEMENTS",
  SET_ADDRESS: "SET_ADDRESS",
  SET_CONTENT: "SET_CONTENT",
  SET_ETHNICITY_OPTIONS: "SET_ETHNICITY_OPTIONS",
  SET_LANGUAGE_OPTIONS: "SET_LANGUAGE_OPTIONS",
  SET_NEXT_PAGE: "SET_NEXT_PAGE",
  SET_PAGE: "SET_PAGE",
  SET_PAGES: "SET_PAGES",
  SET_PREVIOUS_PAGE: "SET_PREVIOUS_PAGE",
  SET_PROFILE_ELEMENTS: "SET_PROFILE_ELEMENTS",
  SET_REQUIRED_FIELDS: "SET_REQUIRED_FIELDS",
  SET_RESIDENT_VACCINATION_OPTIONS: "SET_RESIDENT_VACCINATION_OPTIONS",
  SET_VACCINATION_MANDATORY: "SET_VACCINATION_MANDATORY",
  SET_TERRITORY: "SET_TERRITORY",
  SET_MARKET: "SET_MARKET",
  SET_RECAPTCHA_SITE_ID: "SET_RECAPTCHA_SITE_ID",
  SET_AUTHENTICATED_USER: "SET_AUTHENTICATED_USER"
};

export default constants;
